import React from "react";

const RemoveHotList = () => {
	return (
		<svg width="14.7" height="14.7" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.64901 0.651373C6.1956 0.651768 4.77494 1.08312 3.56666 1.89087C2.35839 2.69863 1.41676 3.84653 0.860841 5.18942C0.304919 6.53231 0.15967 8.00988 0.443458 9.43532C0.727247 10.8608 1.42733 12.17 2.45518 13.1976C3.48304 14.2252 4.79251 14.9249 6.21802 15.2083C7.64353 15.4917 9.12107 15.3461 10.4638 14.7898C11.8065 14.2335 12.9542 13.2915 13.7616 12.0831C14.569 10.8746 15 9.45378 15 8.00037C15.0009 7.03486 14.8114 6.07865 14.4423 5.18648C14.0732 4.29431 13.5317 3.48371 12.8489 2.80108C12.1661 2.11846 11.3553 1.57721 10.463 1.20833C9.57078 0.839454 8.61452 0.650189 7.64901 0.651373ZM11.323 10.6384L10.287 11.6744L7.64901 9.03637L5.01001 11.6744L3.974 10.6384L6.61201 8.00037L3.974 5.36137L5.01001 4.32537L7.64901 6.96337L10.287 4.32537L11.323 5.36137L8.68501 8.00037L11.323 10.6384Z"
				fill="white"
			/>
		</svg>
	);
};

export default RemoveHotList;
